import { render, staticRenderFns } from "./WalletCashia.vue?vue&type=template&id=deb10c96&scoped=true"
import script from "./WalletCashia.vue?vue&type=script&lang=js"
export * from "./WalletCashia.vue?vue&type=script&lang=js"
import style0 from "./WalletCashia.vue?vue&type=style&index=0&id=deb10c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb10c96",
  null
  
)

export default component.exports